import React, { useCallback, useState, useRef, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the Data Grid

const CompanionGrid = (props) => {
    const gridRef = useRef(null);
    const [rowData, setRowData] = useState(props.data);
    const [lastRowOp, setLastRowOp] = useState("NONE");

    useEffect(() => {
        setRowData(props.data);
        setColDefs([ ...props.columnDefs,
            { field: "Delete", cellRenderer: DeleteButton }
       ]);
    }, [props.data, props.columnDefs]);
    // const createItem =(() => {



    const onDelete = (row) => {
        let myTran = {
            remove: [
                row.node.data
            ]
        }
        setLastRowOp('DELETE');
        //lastCompanionRowOp = 'DELETE';
        gridRef.current.api.applyTransaction(myTran);
        props.onRowDelete(row.data);
    };

    const onAdd = () => {

        let newItem = props.createItem(-1);
        let myTran = {
            add: [
                newItem
            ]
        }
        console.log(newItem);
        setLastRowOp('ADD');
        props.onRowAdd(newItem);
        //lastCompanionRowOp = 'ADD';
        gridRef.current.api.applyTransaction(myTran);
    };

    const stopEditingAndSave = () => {
        gridRef.current.api.stopEditing();

        // Collect the grid's current values for every row (all rows) and let the parent diff them against the stored records.
        let rows = [];
        gridRef.current.api.forEachNode(node => rows.push(node.data));
        props.onSave(rows);
    }

    const getRowId = useCallback(function (params) {
        return params.data.rowId.toString();
    }, []);

    const DeleteButton = p => {
        return <><button onClick={() => onDelete(p)} className="btn btn-danger btn-sm" ><i className='fa-solid fa-times' /></button></>;
    }

    const onCellEditingStopped = (event) => {

        console.log("cellEditingStopped");
        console.log(event);

        props.onRowEdit(event.data);
      };

    // Column Definitions: Defines the columns to be displayed.
    const [colDefs, setColDefs] = useState([ ...props.columnDefs,
         { field: "Delete", cellRenderer: DeleteButton }
    ]);

    const onRowDataUpdated = (event) => {

        if(lastRowOp === 'ADD')
        {
            gridRef.current.api.paginationGoToLastPage();
            let maxRowIndex = 0;
            gridRef.current.api.forEachNode(function (node) {
                if(node.rowIndex > maxRowIndex) maxRowIndex = node.rowIndex;
            });
            gridRef.current.api.startEditingCell({rowIndex: maxRowIndex, colKey: 'BATCH'});
        }
      };

    return (
        // wrapping container with theme & size
        <div
         className="ag-theme-quartz" // applying the Data Grid theme
         style={{ height: props.gridHeight-160 }} // the Data Grid will fill the size of the parent container
        >
          <AgGridReact
              ref={gridRef}
              rowData={rowData}
              columnDefs={colDefs}
              getRowId={getRowId}
              paginationPageSize={10}
              paginationPageSizeSelector={[10, 20, 50, 100]}
              pagination={true}
              onRowDataUpdated={onRowDataUpdated}
              onCellEditingStopped={onCellEditingStopped}

          />
          <div className="ms-2 mt-2">
          <button className="btn btn-success" onClick={onAdd} ><i className='fa-solid fa-plus'/>{' '}Add Row</button>
          </div>
          <div className="ms-2 mt-2">
            <button className="btn btn-primary" onClick={stopEditingAndSave}><i className='fa-solid fa-save'/>{' '}Save Changes</button>
          </div>
        </div>

       )

};

export default CompanionGrid